import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { useCurrentStep } from '../hooks/useCurrentStep';
import MessagingContainer from '../messaging/MessagingContainer';
import { useMessage } from '../messaging/useMessage';
import { devices } from '../styles/viewports.styles';
import { ContentHolder } from './AppViewComponent.styles';
const FlowStepMessage = styled.div.withConfig({
  displayName: "AppMessagingComponent__FlowStepMessage",
  componentId: "yj9zta-0"
})(["display:grid;align-content:center;margin:2rem auto;@media ", "{margin:0 auto;}"], devices.desktop);
export const AppMessagingComponent = () => {
  const {
    currentStep
  } = useCurrentStep();
  const {
    shouldDisplayMessaging
  } = useMessage();
  return shouldDisplayMessaging ? /*#__PURE__*/_jsx(FlowStepMessage, {
    "data-step": currentStep,
    children: /*#__PURE__*/_jsx(ContentHolder, {
      children: /*#__PURE__*/_jsx(MessagingContainer, {})
    })
  }) : null;
};